import React, { useEffect, useState } from "react";
import "./My_Account.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Left_Tabs from "./left_tabs/Left_Tabs";
import Ordered from "./all_tabs/ordered/Ordered";
import Personal_Info from "./all_tabs/personal_info/Personal_Info";
import Delivered from "./all_tabs/delivered/Delivered";
import Return from "./all_tabs/return/Return";
import Cancelled from "./all_tabs/cancelled/Cancelled";
import Manage_Address from "./all_tabs/manage_address/Manage_Address";
import Change_Password from "./all_tabs/change_password/Change_Password";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrder } from "../../features/order/orderSlice";
import Replace from "./all_tabs/replace/Replace";
import { useLocation } from "react-router-dom";

const My_Account = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "My Account", link: "", isActive: true },
  ];

  // const [selectedTab, setSelectedTab] = useState("PERSONAL INFORMATION");

  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState(
    location.state?.activeTab || "PERSONAL INFORMATION",
  );

  // Mobile dropdown sends uppercase labels, desktop sends title case
  const currentTab = selectedTab?.toUpperCase();

  return (
    <section className="My_Account">
      <div className="container">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <div className="main_content_div">
          <div className="row">
            <div className="col-lg-4 col-md-3">
              <div className="tabs_holder_div">
                {/* <Left_Tabs setSelectedTab={setSelectedTab} /> */}
                <Left_Tabs
                  setSelectedTab={setSelectedTab}
                  selectedTab={selectedTab}
                />
              </div>
            </div>
            <div className="col-lg-8 col-md-9">
              <div className="tabs_container">
                {currentTab === "PERSONAL INFORMATION" && <Personal_Info />}

                {currentTab === "ORDERED" && <Ordered type={"Ordered"} />}

                {currentTab === "DELIVERED" && <Delivered type={"Delivered"}/>}

                {currentTab === "RETURN" && <Return type={"Return"} />}

                {currentTab === "REPLACE" && <Replace type={"Replace"} />}

                {currentTab === "CANCELLED" && <Cancelled />}

                {currentTab === "MANAGE ADDRESS" && <Manage_Address />}

                {currentTab === "CHANGE PASSWORD" && <Change_Password />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default My_Account;
